module.exports = __webpack_public_path__ + "img/工厂.db1af3be.png";